import { styled } from '@mui/material/styles';
import { AI } from 'theme/prismDesignTokens';
import { HighlightLayerProps } from './HighlightLayer.props';


export const StyledHighlightedTextMarker = styled('div')<{ isCurrentHighlight: boolean }>(({ isCurrentHighlight }) => ({
  backgroundColor: '#fce4a9',
  display: 'inline',
  position: 'relative',
  ...(isCurrentHighlight && {
    outline: '2px solid #1976d2',
    outlineOffset: '0px',
  }),
  '& > span': {
    backgroundColor: 'inherit',
    display: 'inline',
    position: 'relative',
  },
}));


const HIGHLIGHT_COLORS = {
  citation: { focused: '#fce4a9', unfocused: 'yellow', outline: '#1976d2' },
  search: { focused: '#a8d8ff', unfocused: '#a8d8ff', outline: '#0969da' },
  // Pending review-mode citation (SCAL-8976/8986): same YELLOW fill as a normal citation,
  // set apart only by an AI-purple (#A614FF) OUTLINE. The old full purple fill was hard to
  // read; pending now reads as yellow + purple border while accepted citations stay plain
  // yellow via the 'citation' variant. Fill is always yellow; only the outline differs.
  ai: { focused: '#fce4a9', unfocused: 'yellow', outline: AI },
} as const;

const HighlightLayer = ({ rects, isFocused, pageWidth, renderedWidth, focusedId, variant = 'citation' }: HighlightLayerProps) => {
  const scale = renderedWidth / pageWidth;
  const colors = HIGHLIGHT_COLORS[variant];
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}>
      {rects.map((rect, i) => (
        <div
          key={i}
          id={i === 0 && focusedId ? focusedId : undefined}
          style={{
            position: 'absolute',
            left: `${rect.left * scale}px`,
            top: `${rect.top * scale}px`,
            width: `${rect.width * scale}px`,
            height: `${rect.height * scale}px`,
            backgroundColor: isFocused ? colors.focused : colors.unfocused,
            outline: `2px solid ${colors.outline}`,
            mixBlendMode: 'multiply',
            transition: 'background-color 0.3s ease',
          }}
        />
      ))}
    </div>
  );
};

export default HighlightLayer;
